<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import * as firebase from "firebase/app"

export default {
  name: 'App',
  metaInfo: {
    changed(metaInfo) {
      firebase.analytics().setCurrentScreen(metaInfo.title);
      firebase.analytics().logEvent("page_view");
      firebase.analytics().logEvent("screen_view", {
        screen_name: metaInfo.title,
      })
    }
  },
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Roboto+Slab:400,700|Roboto:400,500,700&subset=latin-ext');
@import url('https://fonts.googleapis.com/css?family=Montserrat&display=swap');
@import url('https://fonts.googleapis.com/css?family=Noto+Sans&display=swap');
@import url('https://fonts.googleapis.com/css?family=Noto+Sans+KR&display=swap');
/* @import url('https://fonts.googleapis.com/css?family=Noto+Serif+KR&display=swap'); */
@import url('https://fonts.googleapis.com/css?family=Bree+Serif&display=swap');
@import url(//spoqa.github.io/spoqa-han-sans/css/SpoqaHanSans-kr.css);
@import './assets/main.css';

html {
  height: 100%;
  overflow: hidden;
}

body {
   scrollbar-width: none;
   -ms-overflow-style: none;
   overflow: -moz-scrollbars-none;
}

</style>



// WEBPACK FOOTER //
// src/App.vue